import * as R from 'ramda';

export interface SortParam {
  index: number;
  ascending: boolean;
}

// Cycles a column through ascending, descending, then unsorted. Sorting a new column appends it,
// or replaces the whole list when singleColumnSort is set.
export const getNextSortParamList = (
  sortParamList: SortParam[],
  index: number,
  singleColumnSort: boolean
): SortParam[] => {
  const listIndex = sortParamList.findIndex(param => param.index === index);
  if (listIndex === -1) {
    const newParam = { index, ascending: true };
    return singleColumnSort ? [newParam] : [...sortParamList, newParam];
  }
  if (sortParamList[listIndex].ascending) {
    return R.update(listIndex, { index, ascending: false }, sortParamList);
  }
  return R.remove(listIndex, 1, sortParamList);
};
